import createPersistedState from '~/react-hooks/use-persisted-state';
const previousTemplateRecordsHook = createPersistedState('previous-template');

export interface PreviousTemplateRecords extends Record<string, string> {}

export interface PreviousTemplateRecordsProps {
  previousTemplateRecords: PreviousTemplateRecords;
  setPreviousTemplateRecords: (
    previousTemplate: PreviousTemplateRecords
  ) => void;
}

export function usePreviousTemplateRecords() {
  const [previousTemplateRecords, setPreviousTemplateRecords] =
    previousTemplateRecordsHook<string>('');

  const records = parseJsonString(
    previousTemplateRecords
  ) as PreviousTemplateRecords;

  const setRecords = (previousTemplateRecords: PreviousTemplateRecords) => {
    setPreviousTemplateRecords(JSON.stringify(previousTemplateRecords));
  };
  return {
    previousTemplateRecords: records,
    setPreviousTemplateRecords: setRecords,
  } as PreviousTemplateRecordsProps;
}

export function parseJsonString<T>(value: string) {
  try {
    return JSON.parse(value) as T;
  } catch (e) {
    return {};
  }
}
